export const SET_LOCALE = 'settings/setLocale';
export const SET_SIDEBAR_IS_COLLAPSED = 'settings/setSidebarIsCollapsed';
export const SET_SIDEBAR_IS_SHOWN = 'settings/setSidebarIsShown';
export const SET_SIDEBAR_IS_HIDDEN = 'settings/setSidebarIsHidden';
export const SET_TRANSACTION_SCRIPTS_HIDDEN =
  'settings/setTransactionScriptsHidden';
export const SET_TRANSACTION_SCRIPTS_SHOWN =
  'settings/setTransactionScriptsShown';
